import { useEffect, useRef, useState } from "react";
import { fetchLocaleInfo } from "../api/fetchLocaleInfo";

export default function useServerTime(): {
  serverTime: Date;
  isLoading: boolean;
  refetch: () => Promise<void>;
} {
  const [serverTime, setServerTime] = useState(new Date());
  const [isLoading, setIsLoading] = useState(true);

  const serverTimeRef = useRef<number>(-1);

  useEffect(() => {
    void getServerTime();
  }, []);

  const getServerTime = async () => {
    const localeInfo = await fetchLocaleInfo();

    // fetchLocaleInfo의 결과가 undefined이면 로컬 시간 사용
    if (!localeInfo) {
      const now = new Date();
      serverTimeRef.current = now.getTime();
      setServerTime(new Date(serverTimeRef.current));
    } else {
      const now = new Date(localeInfo.server_time);
      serverTimeRef.current = now.getTime();
      setServerTime(now);
    }

    setIsLoading(false);
  };

  return { serverTime, isLoading, refetch: getServerTime };
}
